export enum Region {
  NORTH = 1,
  NORTHEAST = 2,
  SOUTHEAST = 3,
  SOUTH = 4,
  MIDWEST = 5,
}

export enum State {
  AC = 12,
  AL = 27,
  AP = 16,
  AM = 13,
  BA = 29,
  CE = 23,
  DF = 53,
  ES = 32,
  GO = 52,
  MA = 21,
  MT = 51,
  MS = 50,
  MG = 31,
  PA = 15,
  PB = 25,
  PR = 41,
  PE = 26,
  PI = 22,
  RJ = 33,
  RN = 24,
  RS = 43,
  RO = 11,
  RR = 14,
  SC = 42,
  SP = 35,
  SE = 28,
  TO = 17,
}

export enum Dependency {
  FEDERAL = 1,
  STATE = 2,
  MUNICIPAL = 3,
  PRIVATE = 4,
}

export enum Location {
  URBAN = 1,
  RURAL = 2,
}

export enum EducationStage {
  TECHNICAL_COURSE = 1,
  YOUTH_AND_ADULT_EDUCATION = 2,
  EARLY_CHILDHOOD_EDUCATION = 3,
  ELEMENTARY_SCHOOL_EARLY_YEARS = 4,
  ELEMENTARY_SCHOOL_FINAL_YEARS = 5,
  HIGH_SCHOOL = 6,
}

export enum Sphere {
  PUBLIC = 1,
  PRIVATE_CONVENIADA = 2,
  PRIVATE_NAO_CONVENIADA = 3,
}

export type RegionCode = Region
export type StateCode = State
export type DependencyCode = Dependency
export type LocationCode = Location
export type EducationStageCode = EducationStage
export type SphereCode = Sphere

export interface RegionLabelValue {
  label: string
  value: RegionCode
}

export interface DependencyLabelValue {
  label: string
  value: DependencyCode
}

export interface LocationLabelValue {
  label: string
  value: LocationCode
}

export interface EducationStageLabelValue {
  label: string
  value: EducationStageCode
}

export interface SphereLabelValue {
  label: string
  value: SphereCode
}

export interface StateLabelValue {
  label: string
  value: StateCode
}

export type RegionFilter = RegionCode[]
export type DependencyFilter = DependencyCode[]
export type LocationFilter = LocationCode[]
export type SphereFilter = SphereCode[]

export interface GeographicFilters {
  coRegion?: RegionCode
  coUf?: StateCode[]
  coCity?: number[]
}

export interface InstitutionFilters {
  coEntity?: number[]
  tpDependency?: DependencyFilter
  tpLocation?: LocationFilter
  coSphere?: SphereFilter
  stPnldService?: boolean
}

export interface EducationFilters {
  coEducationStage?: EducationStageCode[]
  coYearGrade?: number[]
}

export interface DashboardFilters
  extends GeographicFilters,
    InstitutionFilters,
    EducationFilters {}

export interface BaseMetrics {
  students: number
  classes: number
  schools: number
}

export interface YearMetrics extends BaseMetrics {
  nuCensusYear: number
}

export interface PredictionMetrics extends BaseMetrics {
  nuCensusYear: number
  nuPredictionYear: number
}

export interface ComparativeMetrics {
  census: number
  prediction: number
  stdPercent: number
  classes: number
  schools: number
}
